import { createSelector } from 'reselect'
import getMerchandiseShippingItems from '../items/getMerchandiseShippingItems'
import { groupBy, sum } from 'lib/array/arrayUtils'
import getMerchandiseItems from '../items/getMerchandiseItems'

const getMerchandiseShippingItemViews = createSelector(
  (state: App.State) => getMerchandiseShippingItems(state),
  (state: App.State) => getMerchandiseItems(state),
  (state: App.State) => state.merchandise.merchandiseShipping,
  (shippingItems, merchandiseItems, shipping): App.WithDataStatus<Array<App.Checkout.MerchandiseShippingItemView>> => {
    const merchandiseItemsByShippingId = groupBy(merchandiseItems, item => item.shippingId)

    return {
      // data is ready once we have shipping records for every item
      hasRequiredData: merchandiseItems.every(item => !!shipping[item.variantId]),
      data: shippingItems.map((item): App.Checkout.MerchandiseShippingItemView => ({
        title: 'Shipping',
        item,
        loyalty: {},
        totals: {
          price: 0,
          memberPrice: 0,
          value: 0,
          memberValue: 0,
          surcharge: 0,
          extraGuestSurcharge: 0,
          taxesAndFees: 0,
          otherFees: {
            deliveryFee: sum(merchandiseItemsByShippingId.get(item.shippingId) ?? [], item => shipping[item.variantId]?.price ?? 0),
          }
        },
      }))
    }
  }
)

export default getMerchandiseShippingItemViews
